<template>
<navBack></navBack>
  <div class="page">
    <div class="page-section">
      <t-cell title="客户姓名" :note="stateCustomer.name"></t-cell>
      <t-cell title="客户手机" :note="stateCustomer.mobile"></t-cell>
    </div>

    <div class="page-section">
      <t-cell @click="goChoseProduct" title="消费商品" note="选择" arrow></t-cell>
      <block v-for="(item, index) in productList" :key="item._id || index">
        <t-cell :title="`${item.name} ${item.price / 100}`">
          <template #left-icon>
            <t-icon name="shop" />
          </template>
          <template #right-icon>
            <t-button v-if="ID === 0" size="small" @click.stop="onDelButtonTap(index)">X</t-button>
          </template>
        </t-cell>
      </block>
    </div>

    <div class="page-section">
      <div class="bigInput">
        <t-textarea v-model="CONTENT" class="textarea-example" placeholder="回访内容"></t-textarea>
      </div>

      <t-cell title="再次跟进时间" align-right>
        <template #note>
          <text class="deleteX" v-if="NEXT_FOLLOW_DATE" @click="clearNextFollow">{{ NEXT_FOLLOW_DATE }} 取消</text>
          <t-button v-else size="small" @click="showDatePicker = true">选择</t-button>
        </template>
      </t-cell>
    </div>

    <div class="page-section uploadPannel">
      <t-cell :bordered="false" title="回访图片"></t-cell>

      <t-upload multiple :max="3" accept="image/*" :request-method="uploadFn" @remove="uploadDelect"
        @success="uploadSuccess" />
    </div>

    <div class="confirmBar">
      <t-button theme="primary" size="large" @click="doSubmit" :disabled="isSubmitting">
        {{ isSubmitting ? '提交中...' : '保存' }}
      </t-button>
    </div>
  </div>

  <t-popup v-model:visible="showPopupChoseOrder" placement="bottom">
    <choseOrder :customer-id="customerId" @chose-order="choseThisProduct" @close="closeDialog" />
  </t-popup>

  <t-popup v-model="showDatePicker" placement="bottom">
    <t-date-time-picker :value="pickerValue" :mode="['date']" title="选择时间" :start="minDate" format="YYYY-MM-DD"
      @confirm="onDateConfirm" @cancel="showDatePicker = false" />
  </t-popup>
</template>

<script setup>
import { ref, reactive, onMounted, getCurrentInstance } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Toast } from 'tdesign-mobile-vue'
import choseOrder from '@/components/chose-order.vue'
import { stateCustomer, stateShop } from '@/store'
import navBack  from '@/components/nav-back-top.vue'
// 路由相关
const router = useRouter()
const route = useRoute()
const { proxy } = getCurrentInstance()
const app = proxy.$cloudbase
 
// 响应式数据
const customer = reactive({
  _id: '',
  name: '',
  mobile: ''
})

const customerId = ref('')
const productList = ref([])
const ID = ref(0)
const CONTENT = ref('')
const NEXT_FOLLOW_DATE = ref('')
const pickerValue = ref(new Date())

const tempPicList = ref([]);

const showPopupChoseOrder = ref(false)
const followPicList = ref([])
const isSubmitting = ref(false)
const showDatePicker = ref(false)
const minDate = new Date().toISOString().split('T')[0]

// 日期确认处理
const onDateConfirm = (value) => {
  showDatePicker.value = false
  NEXT_FOLLOW_DATE.value = value
}

// 上传相关函数
const uploadFn = async (file) => {
  try {


    const shopId = stateShop._id
    const timestamp = new Date().getTime()

    const { fileID } = await app.uploadFile({
      cloudPath: `${shopId}_${timestamp}.png`,
      filePath: file[0].raw
    })
 
  
    const res = await app.getTempFileURL({
      fileList: [fileID]
    });

    let url = res.fileList[0].tempFileURL;
    followPicList.value.push(fileID)
    tempPicList.value.push({ url, name: fileID, type: 'image' });

    console.log('上传成功:', url)

    return { status: 'success', response: { url } };
    //return { status: 'success', files: [{ url: url, name: fileID,type:'image'}]};


  } catch (error) {
    console.error('上传失败:', error)
    Toast({ message: '上传失败', theme: 'error' })
    return { status: 'fail', error: '上传失败' }

  }
}

const uploadDelect = (index) => {
  console.log('删除文件索引:', index)
  followPicList.value.splice(index, 1);
}

const uploadSuccess = (res) => {
  console.log('上传成功:', res)

}

// 方法定义
const goChoseProduct = () => {
  showPopupChoseOrder.value = true
}

const choseThisProduct = (productListData) => {
  productList.value = productListData
  closeDialog()
}

const closeDialog = () => {
  showPopupChoseOrder.value = false
}

const onDelButtonTap = (index) => {
  productList.value.splice(index, 1)
}

const clearNextFollow = () => {
  NEXT_FOLLOW_DATE.value = ''
}

const doSubmit = async () => {
  if (isSubmitting.value) return

  if (!CONTENT.value.trim()) {
    Toast({ message: '请输入回访内容', theme: 'error' })
    return
  }

  isSubmitting.value = true

  try {
    const db = app.database()

    // 同步客户信息
    customer._id = stateCustomer._id
    customer.name = stateCustomer.name
    customer.mobile = stateCustomer.mobile

    const data = {
      customerId: customer._id,
      customerName: customer.name,
      customerMobile: customer.mobile,
      content: CONTENT.value,
      nextFollowDate: NEXT_FOLLOW_DATE.value,
      productList: productList.value,
      images: followPicList.value.map(item => item.url || item),
      createdAt: new Date()
    }

    await db.collection('follow_records').add(data)

    Toast({ message: '保存成功', theme: 'success' })

    // 返回上一页
    setTimeout(() => {
      router.back()
    }, 1000)
  } catch (error) {
    console.error('保存失败:', error)
    Toast({ message: '保存失败', theme: 'error' })
  } finally {
    isSubmitting.value = false
  }
}

// 生命周期
onMounted(() => {
  customerId.value = route.query.id
  console.log('customerId:', customerId.value)

  // 初始化客户信息
  customer._id = stateCustomer._id
  customer.name = stateCustomer.name
  customer.mobile = stateCustomer.mobile
})
</script>

<style scoped>
.page {
  padding-bottom: 20vw;

}

.page-section {
  margin-bottom: 2vw;
  background-color: #fff;
}

.bigInput {
  border: 0.5px solid #eee;
}

.deleteX {
  margin-left: 5vw;
  cursor: pointer;
}

.uploadPannel {
  padding: 0;
}

.confirmBar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20vw;
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 -1px 34px rgba(0, 0, 0, 0.1);
  z-index: 999;
}

.textarea-example {
  min-height: 30vw;
}
</style>